import implyVariantFromSelections from "./implyVariantFromSelections";

const getIndicativePrice = ({
  selectedColourWayId,
  selectedVariantId,
  variants
}) => {
  const { price } = implyVariantFromSelections({
    selectedColourWayId,
    selectedVariantId,
    variants
  });

  return { price };
};

export default getIndicativePrice;
